import { Icon } from '@material-ui/core';

export const ImageIcon = ({ image }) => {
  return (
    <Icon style={{ width: '0.85em', height: '0.85em', display: 'flex', alignItems: 'center' }} >
      <img style={{ width: '100%' }} src={image} alt="" />
    </Icon>
  );
};